import React from 'react'
import { Modal, Button, Input, Label } from '@/shared/ui'
import { ensureCustomer } from '../services/customerService'

type Props = {
  open: boolean
  onOpenChange: (v: boolean) => void
  onCreated?: () => void
}

export default function CustomerCreateModal({ open, onOpenChange, onCreated }: Props) {
  const [email, setEmail] = React.useState('')
  const [name, setName] = React.useState('')
  const [phone, setPhone] = React.useState('')
  const [saving, setSaving] = React.useState(false)
  const [error, setError] = React.useState<string | null>(null)

  React.useEffect(() => {
    if (!open) return
    setEmail(''); setName(''); setPhone(''); setSaving(false); setError(null)
  }, [open])

  function isValidEmail(v: string) {
    return /.+@.+\..+/.test(v.trim())
  }

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault()
    const em = email.trim().toLowerCase()
    if (!isValidEmail(em)) { setError('Informe um e-mail válido'); return }
    setError(null)
    try {
      setSaving(true)
      await ensureCustomer(em, name.trim() || undefined, phone.trim() || undefined)
      onCreated?.()
      onOpenChange(false)
    } catch (err: any) {
      setError(err?.message || 'Falha ao criar cliente')
    } finally { setSaving(false) }
  }

  return (
    <Modal open={open} onOpenChange={onOpenChange} className="p-6 sm:p-8" style={{ width: 560, maxWidth: 560 }}>
      <div className="mb-4 text-xl font-semibold">Novo cliente</div>
      <form className="grid gap-4" onSubmit={onSubmit}>
        {error && <div className="rounded-md border border-destructive/30 bg-destructive/10 p-2 text-sm text-destructive-foreground">{error}</div>}
        <div className="space-y-1.5">
          <Label>E-mail do titular</Label>
          <Input value={email} onChange={(e)=> setEmail(e.target.value)} type="email" placeholder="ex.: cliente@exemplo.com" required />
        </div>
        <div className="space-y-1.5">
          <Label>Nome do titular (opcional)</Label>
          <Input value={name} onChange={(e)=> setName(e.target.value)} placeholder="Nome completo" />
        </div>
        <div className="space-y-1.5">
          <Label>Telefone (opcional)</Label>
          <Input value={phone} onChange={(e)=> setPhone(e.target.value)} placeholder="(DDD) 99999-9999" />
        </div>
        <div className="mt-2 flex justify-end gap-2">
          <Button type="button" variant="outline" onClick={()=> onOpenChange(false)}>Cancelar</Button>
          <Button type="submit" disabled={saving}>{saving ? 'Criando...' : 'Criar cliente'}</Button>
        </div>
      </form>
    </Modal>
  )
}

